export default class TitlePath{

    static srPath(product){
        return `Cene ${product} na pijacama`;
    }
    static enPath(product){
        return `${product} prices on the markets`;
    }
    static enPathSingle(product){
        return `Prices of ${product} on the markets`;
    }
     
}
